import $ from 'jquery'
import _ from 'lodash'
import './main.scss'

import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay, A11y } from 'swiper/modules'

// Swiper styles (adjust paths if needed)
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

const selectedFilters = {
  month: null,
  year: null,
  region: null
}

const rowsPerPage = 10
let currentPage = 1

const translationMap = {
  en: {
    pages: [
      'Page 1',
      'Page 2',
      'Page 3',
      'Page 4',
      'Page 5',
      'Page 6',
      'Page 7',
      'Page 8',
      'Page 9',
      'Page 10'
    ],
    previous: 'Previous',
    next: 'Next'
  },
  tc: {
    pages: [
      '第一頁',
      '第二頁',
      '第三頁',
      '第四頁',
      '第五頁',
      '第六頁',
      '第七頁',
      '第八頁',
      '第九頁',
      '第十頁'
    ],
    previous: '上一頁',
    next: '下一頁'
  },
  sc: {
    pages: [
      '第一頁',
      '第二頁',
      '第三頁',
      '第四頁',
      '第五頁',
      '第六頁',
      '第七頁',
      '第八頁',
      '第九頁',
      '第十頁'
    ],
    previous: '上一頁',
    next: '下一頁'
  }
}
let currentLocale = 'tc'

function enableMainAria(enable) {
  // all focusable selectors
  const focusableSelector =
    'a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"]), .images.lightbox img'

  // select ALL focusable elements OUTSIDE the notification
  const $targets = $(focusableSelector).filter(function () {
    return (
      $(this).closest('.notifications').length === 0 &&
      $(this).closest('.routes-button-popup-overlay').length === 0
    )
  })

  if (enable) {
    // restore original tabindex / aria-hidden
    $targets.each(function () {
      const $el = $(this)

      const originalTab = $el.data('original-tabindex')
      if (originalTab !== undefined) {
        $el.attr('tabindex', originalTab)
      } else {
        $el.removeAttr('tabindex')
      }

      $('.footer-banner').show()
    })
    $('main').removeAttr('aria-hidden')
  } else {
    // disable all main-page tabbables
    $targets.each(function () {
      const $el = $(this)

      // store original tabindex only ONCE
      if (!$el.data('original-tabindex')) {
        const existing = $el.attr('tabindex')
        $el.data('original-tabindex', existing !== undefined ? existing : null)
      }

      // force remove from tab order
      $el.attr('tabindex', '-1')
      $('.footer-banner').hide()
    })
    $('main').attr('aria-hidden', 'true')
  }
}

function getClosedNotificationKeys() {
  try {
    const raw = localStorage.getItem('closedNotifications')
    return raw ? JSON.parse(raw) : []
  } catch (e) {
    return []
  }
}

function saveClosedNotificationKeys(keys) {
  try {
    localStorage.setItem('closedNotifications', JSON.stringify(keys))
  } catch (e) {
    // ignore storage errors
  }
}

function applyClosedNotifications() {
  const closedKeys = getClosedNotificationKeys()
  const $wrapper = $('.notifications')
  const $all = $wrapper.find('.close-object')

  let total = 0
  let closed = 0

  $all.each(function () {
    total++
    const $n = $(this)
    const key = $n.data('key')

    // if (key && closedKeys.includes(String(key))) {
    //   $n.addClass('close')
    //   closed++
    // }
  })

  // If there is at least one notification NOT closed → show wrapper
  console.log(444, total, closed)
  if (total > 0 && closed < total) {
    $wrapper.removeClass('close')
  } else {
    // all closed (or none at all) → keep wrapper closed
    $wrapper.addClass('close')
  }
}

function setupNotificationCloseButton() {
  const $wrapper = $('.notifications')

  // delegated handler in case notifications are rendered dynamically
  $wrapper.on('click', '.close-button', function () {
    const $notification = $(this).closest('.close-object')
    const key = $notification.data('key')

    // visually close this notification
    $notification.addClass('close')

    // store closed key
    if (key) {
      const closedKeys = getClosedNotificationKeys()
      const keyStr = String(key)
      if (!closedKeys.includes(keyStr)) {
        closedKeys.push(keyStr)
        saveClosedNotificationKeys(closedKeys)
      }
    }

    // check if all notifications are closed now
    const total = $wrapper.find('.close-object').length
    const closed = $wrapper.find('.close-object.close').length

    if (total > 0 && closed === total) {
      $wrapper.addClass('close')
      enableMainAria(true)
    }
  })
}

function setupScrollToTop() {
  const $btn = $('.backtop')

  // hide at start
  $btn.hide()

  // show/hide on scroll
  $(window).on('scroll', function () {
    if ($(this).scrollTop() > 200) {
      $btn.fadeIn()
    } else {
      $btn.fadeOut()
    }
  })

  // scroll to top on click
  $btn.on('click', function (e) {
    e.preventDefault()
    $('html, body').animate({ scrollTop: 0 }, 400)
  })
}

function initFooterBannerSwiper() {
  const swiper = new Swiper('.footer-banners-swiper', {
    modules: [Navigation, Pagination, Autoplay, A11y],
    slidesPerView: 5,
    slidesPerGroup: 5,
    spaceBetween: 20,
    breakpoints: {
      0: {
        slidesPerView: 3,
        slidesPerGroup: 3
      },
      769: {
        slidesPerView: 5,
        slidesPerGroup: 5
      },
      1281: {
        slidesPerView: 5,
        slidesPerGroup: 5
      }
    },
    pagination: {
      el: '.footer-banner .swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.footer-banner .swiper-button-next',
      prevEl: '.footer-banner .swiper-button-prev'
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    a11y: {
      enabled: true
    },
    keyboard: {
      enabled: true
    }
  })

  // Start paused by default
  // swiper.autoplay.stop()
  let isPlaying = true
  $('.swiper-bottom-controls .swiper-play-pause').on('click', function () {
    if (isPlaying) {
      swiper.autoplay.stop()
      isPlaying = false
      $(this).parent().removeClass('is-playing')
    } else {
      swiper.autoplay.start()
      isPlaying = true
      $(this).parent().addClass('is-playing')
    }
  })
  enhanceSwiperPaginationAccessibility(swiper)
}

function enhanceSwiperPaginationAccessibility(swiper) {
  const $pagination = $('.footer-banner .swiper-pagination')

  function setupBullets() {
    const $bullets = $pagination.find('.swiper-pagination-bullet')
    $bullets.each(function (index) {
      $(this)
        .attr('tabindex', '0')
        .attr('role', 'button')
        .attr('aria-label', _.get(translationMap, `${currentLocale}.pages.${index}`))
    })

    // Enter / Space = click 個 bullet
    $bullets.on('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        $(this).trigger('click')
      }
    })
  }

  // 初始化時先 set 一次
  setupBullets()

  // Swiper 有時會 rebuild pagination → 重新 set 一次
  swiper.on('paginationUpdate', () => {
    setupBullets()
  })
}

function initExploreItemsSwiper() {
  const swiper = new Swiper('.cards-swiper .swiper', {
    modules: [Navigation, Pagination, Autoplay, A11y],
    slidesPerView: 6,
    slidesPerGroup: 6,
    spaceBetween: 50,
    breakpoints: {
      0: {
        slidesPerView: 2,
        slidesPerGroup: 2
      },
      769: {
        slidesPerView: 3,
        slidesPerGroup: 3
      },
      1281: {
        slidesPerView: 6,
        slidesPerGroup: 6
      }
    },
    // pagination: {
    //   el: '.footer-banners-swiper .swiper-pagination',
    //   clickable: true
    // },
    navigation: {
      nextEl: '.cards-swiper .swiper-button-next',
      prevEl: '.cards-swiper .swiper-button-prev'
    },
    a11y: {
      enabled: true
    },
    keyboard: {
      enabled: true
    }
  })

  // Start paused by default
  // swiper.autoplay.stop()
  let isPlaying = true

  $('.footer-banners-swiper .swiper-play-pause').on('click', function () {
    if (isPlaying) {
      swiper.autoplay.stop()
      isPlaying = false
      $(this).removeClass('is-playing').addClass('is-paused')
    } else {
      swiper.autoplay.start()
      isPlaying = true
      $(this).removeClass('is-paused').addClass('is-playing')
    }
  })
}

function initMapOverlay() {
  var baseWidth = 2560
  var baseHeight = 1090

  $('.map .overlay').each(function () {
    var $el = $(this)

    // Read pixel values from data- attributes
    var leftPx = parseFloat($el.data('left')) || 0
    var topPx = parseFloat($el.data('top')) || 0
    var widthPx = parseFloat($el.data('width')) || 0
    var bottomPx = parseFloat($el.data('bottom')) || 0

    // Height = bottom - top (or data-height if you have it)
    var heightPx = bottomPx ? bottomPx - topPx : 0

    // Convert to %
    var leftPct = (leftPx / baseWidth) * 100
    var topPct = (topPx / baseHeight) * 100
    var widthPct = (widthPx / baseWidth) * 100
    var heightPct = (heightPx / baseHeight) * 100

    // Apply as CSS
    $el.css({
      position: 'absolute',
      left: leftPct + '%',
      top: topPct + '%',
      width: widthPct + '%',
      height: heightPct + '%'
    })
  })
}

function initSelect() {
  $('.select').on('click', function (e) {
    e.stopPropagation()
    const $parent = $(this).parent()

    $('.select').not(this).parent().removeClass('active keyboard-focus')

    $parent.toggleClass('active')

    // if we just closed it, also remove keyboard-focus
    if (!$parent.hasClass('active')) {
      $parent.removeClass('keyboard-focus')
      $(this).attr('aria-expanded', 'false')
    } else {
      $(this).attr('aria-expanded', 'true')
    }
  })

  $(document).on('click', function () {
    $('.select').parent().removeClass('active keyboard-focus')
  })

  $('.select, .select + ul.menu').on('focusin', function () {
    $(this).closest('.menu-container').find('.select').attr('aria-expanded', 'true')
  })

  $('.select, .select + ul.menu').on('focusout', function () {
    $(this).closest('.menu-container').find('.select').attr('aria-expanded', 'false')
  })
}

function initFilters() {
  $('.filters .menu a').on('click', function (e) {
    e.preventDefault()

    const $item = $(this)
    const value = $item.data('value')
    const title = $item.data('title')
    const field = $item.data('field')
    const $container = $item.closest('.menu-container')
    const $select = $container.find('.select')

    selectedFilters[field] = value

    // 🏷 Update the displayed label
    $select.html(`${title} <img class="icon-arrow" src="/assets/icons/icon-arrow-down.svg" alt="">`)

    // Close dropdown
    $container.removeClass('active')

    // 👇 stays page (table)
    const $filtersSection = $item.closest('.filters')
    if ($filtersSection.hasClass('bb-filters') || $filtersSection.hasClass('camp-filters')) {
      applyTableFilters(true)
    } else {
      applyCardFilters()
    }
  })

  // 3) Click outside = close all
  $(document).on('click', function () {
    $('.menu-container').removeClass('active')
  })
}

function applyTableFilters(resetPage = true) {
  const $rows = $('.table.section tbody .card')
  if (!$rows.length) return

  $rows.each(function () {
    const $row = $(this)
    let match = true

    // Only region filter for now
    if (selectedFilters.region && selectedFilters.region !== '') {
      if ($row.data('region') !== selectedFilters.region) {
        match = false
      }
    }

    // Store whether this row matches current filters
    $row.data('match', match)
  })

  updateHotelPagination(resetPage)
}

function updateHotelPagination(resetPage = false) {
  const $tableSection = $('.table.section')
  if (!$tableSection.length) return

  const $allRows = $tableSection.find('tbody .card')

  // Rows that match filters (default: all, if no match flag yet)
  const $matchedRows = $allRows.filter(function () {
    const match = $(this).data('match')
    return typeof match === 'undefined' ? true : match
  })

  if (resetPage) {
    currentPage = 1
  }

  const totalRows = $matchedRows.length
  const totalPages = Math.max(1, Math.ceil(totalRows / rowsPerPage))

  if (currentPage > totalPages) {
    currentPage = totalPages
  }

  const startIdx = (currentPage - 1) * rowsPerPage
  const endIdx = startIdx + rowsPerPage

  // Hide all, then show only current page (among matched)
  $allRows.hide()
  const $rowsInPage = $matchedRows.slice(startIdx, endIdx)
  $rowsInPage.show()

  // Build pagination UI
  const $pagination = $tableSection.find('.table-pagination')
  if (!$pagination.length) return

  if (totalPages <= 1) {
    $pagination.empty().hide()
    return
  }

  let html = ''
  let textPrevious = _.get(translationMap, `${currentLocale}.previous`)
  let textNext = _.get(translationMap, `${currentLocale}.next`)
  html += `<button type="button" class="page-arrow prev-page" aria-label="${textPrevious}" >&lt;</button>`

  for (let i = 1; i <= totalPages; i++) {
    html += `<button type="button" class="page-number${i === currentPage ? ' is-active' : ''}" data-page="${i}" aria-label="${_.get(translationMap, `${currentLocale}.pages.${i - 1}`)}" aria-current="${i === currentPage ? 'true' : 'false'}">${i}</button>`
  }

  html += `<button type="button" class="page-arrow next-page" aria-label="${textNext}">&gt;</button>`

  $pagination.html(html).show()
}

function applyCardFilters() {
  $('.card').each(function () {
    const $card = $(this)
    const region = $card.data('region') // e.g. "tung-chung"
    const dateStr = String($card.data('date')) // e.g. "2026-3-9"

    let show = true

    // Parse date into year / month
    let yearNum = null
    let monthNum = null
    if (dateStr && dateStr.includes('-')) {
      const parts = dateStr.split('-') // ["2026","3","9"]
      yearNum = parseInt(parts[0], 10)
      monthNum = parseInt(parts[1], 10)
    }

    // Region filter
    if (selectedFilters.region && selectedFilters.region !== '') {
      if (region !== selectedFilters.region) show = false
    }

    // Year filter
    if (selectedFilters.year && selectedFilters.year !== '') {
      const filterYear = parseInt(selectedFilters.year, 10)
      if (yearNum !== filterYear) show = false
    }

    // Month filter
    if (selectedFilters.month && selectedFilters.month !== '') {
      const filterMonth = parseInt(selectedFilters.month, 10)
      if (monthNum !== filterMonth) show = false
    }

    $card.toggle(show)
  })

  // Optional: hide whole section if no cards visible inside
  $('.cards.section').each(function () {
    const $section = $(this)
    $section.show()
    const visibleCards = $section.find('.card:visible').length
    $section.toggle(visibleCards > 0)
  })
  const commingSoonVisibleCards = $('.coming-soon .card:visible').length
  if (commingSoonVisibleCards) {
    $('.past-event').addClass('extra-margin-top')
  } else {
    $('.past-event').removeClass('extra-margin-top')
  }

  const visibleCards = $('.coming-soon .card:visible, .past-events .card:visible').length
  if (visibleCards) {
    $('.no-events-text-block').addClass('hidden')
  } else {
    $('.no-events-text-block').removeClass('hidden')
  }
}

function initPagination() {
  applyTableFilters()
  // Click page number
  $(document).on('click', '.table-pagination .page-number', function () {
    const page = parseInt($(this).data('page'), 10)
    if (!isNaN(page)) {
      currentPage = page
      updateHotelPagination(false)
      scrollToTable()
    }
  })

  // Click prev
  $(document).on('click', '.table-pagination .prev-page', function () {
    if (currentPage > 1) {
      currentPage--
      updateHotelPagination(false)
      scrollToTable()
    }
  })

  // Click next
  $(document).on('click', '.table-pagination .next-page', function () {
    const $rows = $('.table.section tbody .card')
    const $matchedRows = $rows.filter(function () {
      const match = $(this).data('match')
      return typeof match === 'undefined' ? true : match
    })
    const totalPages = Math.max(1, Math.ceil($matchedRows.length / rowsPerPage))

    if (currentPage < totalPages) {
      currentPage++
      updateHotelPagination(false)
      scrollToTable()
    }
  })
}

function scrollToTable() {
  const $target = $('#table')
  if (!$target.length) return

  // adjust -80 if you have a fixed header
  $('html, body').animate({ scrollTop: $target.offset().top - 80 }, 400)
}

function initLightbox() {
  var $thumbs = $('.lightbox img')
  var $overlay = $('#lightbox-overlay')
  var $image = $overlay.find('.lightbox-image')
  var $caption = $overlay.find('.lightbox-caption')
  var currentIndex = 0
  var lastFocusedElement = null // to restore focus when closing

  $thumbs.each(function () {
    var title = $(this).data('title') || ''
    $(this)
      .attr('tabindex', '0')
      .attr('role', 'button')
      .attr('aria-label', title)
      .attr('alt', title)
  })

  $thumbs.on('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      var index = $thumbs.index(this)
      openLightbox(index)
    }
  })

  // Make overlay itself focusable so it can hold initial focus
  $overlay.attr('tabindex', '-1')

  function openLightbox(index) {
    currentIndex = index
    var $currentThumb = $thumbs.eq(currentIndex)
    var src = $currentThumb.data('image') || $currentThumb.attr('src')
    var title = $currentThumb.data('title') || ''

    $image.attr('src', src)
    $image.attr('alt', title)
    $caption.text(title)

    // remember where focus was before opening
    lastFocusedElement = document.activeElement

    $overlay.addClass('active')
    $('main').attr('aria-hidden', 'true')
    $('body > *:not(#lightbox-overlay)').attr('aria-hidden', 'true')

    // focus the overlay itself (not the close button)
    setTimeout(function () {
      $overlay.trigger('focus')
    }, 0)
  }
  function updateLightboxImage(index) {
    currentIndex = index
    var $currentThumb = $thumbs.eq(currentIndex)
    var src = $currentThumb.data('image') || $currentThumb.attr('src')
    var title = $currentThumb.data('title') || ''

    $image.attr('src', src)
    $caption.text(title)
  }

  function closeLightbox() {
    $overlay.removeClass('active')
    $('main').removeAttr('aria-hidden')
    $('body > *:not(#lightbox-overlay)').removeAttr('aria-hidden')

    // restore focus back to where it was
    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      setTimeout(() => lastFocusedElement.focus(), 50)
    }
  }

  function changeImage(step) {
    currentIndex += step

    if (currentIndex < 0) {
      currentIndex = $thumbs.length - 1 // wrap to last
    } else if (currentIndex >= $thumbs.length) {
      currentIndex = 0 // wrap to first
    }

    updateLightboxImage(currentIndex)
  }

  // Click on thumbnails
  $thumbs.on('click', function () {
    var index = $thumbs.index(this)
    openLightbox(index)
  })

  // Prev / Next buttons
  $overlay.find('.lightbox-prev').on('click', function (e) {
    e.stopPropagation()
    changeImage(-1)
  })

  $overlay.find('.lightbox-next').on('click', function (e) {
    e.stopPropagation()
    changeImage(1)
  })

  // Close button
  $overlay.find('.lightbox-close').on('click', function (e) {
    e.stopPropagation()
    closeLightbox()
  })

  // Click outside content to close
  $overlay.on('click', function (e) {
    if ($(e.target).is('#lightbox-overlay')) {
      closeLightbox()
    }
  })

  // Keyboard: ESC, arrows, and Tab focus trap
  $(document).on('keydown', function (e) {
    if (!$overlay.hasClass('active')) return

    // Trap Tab / Shift+Tab inside lightbox
    if (e.key === 'Tab') {
      var $focusable = $overlay
        .find('button, [href], [tabindex]:not([tabindex="-1"])')
        .filter(':visible')

      if ($focusable.length === 0) return

      // DOM order: prev → close → next
      var domFirst = $focusable[0]
      var domLast = $focusable[$focusable.length - 1]

      // Preferred element for the *first* Tab from overlay
      var preferredFirst = domFirst
      var $close = $overlay.find('.lightbox-close')
      if ($close.length) {
        preferredFirst = $close[0]
      }
      // If you want left arrow as first Tab target instead:
      // var $prev = $overlay.find('.lightbox-prev')
      // if ($prev.length) preferredFirst = $prev[0]

      // FIRST TAB: overlay focused → jump to preferredFirst (e.g. close button)
      if (document.activeElement === $overlay[0]) {
        e.preventDefault()
        $(preferredFirst).trigger('focus')
        return
      }

      // After that, keep normal tab order, only loop at ends
      if (e.shiftKey) {
        // Shift+Tab: from first (DOM first = left arrow) → go to last (right arrow)
        if (document.activeElement === domFirst) {
          e.preventDefault()
          $(domLast).trigger('focus')
        }
      } else {
        // Tab: from last (right arrow) → go to first (left arrow)
        if (document.activeElement === domLast) {
          e.preventDefault()
          $(domFirst).trigger('focus')
        }
      }

      return
    }

    // ESC / arrow keys
    if (e.key === 'Escape') {
      e.preventDefault()
      closeLightbox()
    } else if (e.key === 'ArrowLeft') {
      e.preventDefault()
      changeImage(-1)
    } else if (e.key === 'ArrowRight') {
      e.preventDefault()
      changeImage(1)
    }
  })
}

function initRouteSafetyButton() {
  $('.routes-button-popup button').on('click', function () {
    $('.routes-button-popup .overlay').addClass('active')
    enableMainAria(false)
  })
  $('.routes-button-popup .close-button').on('click', function () {
    $('.routes-button-popup .overlay').removeClass('active')
    enableMainAria(true)
  })
}

function initMapKeyboard() {
  $('.map .overlay').each(function () {
    const $overlay = $(this)

    // 當 overlay 裏面任何元素得到焦點 → 開 dialog
    $overlay.on('focusin', function () {
      $overlay.addClass('keyboard-focus')
    })

    // 失去焦點 → 收起 dialog
    $overlay.on('focusout', function (e) {
      const related = e.relatedTarget
      if (!related || !$.contains($overlay[0], related)) {
        $overlay.removeClass('keyboard-focus')
      }
    })
  })
}

function initKeyboardFocusObject() {
  $('.keyboard-focus-object').each(function () {
    const $parent = $(this).parent()

    $parent.on('focusin', function () {
      $parent.addClass('keyboard-focus')
    })
    $parent.on('focusout', function (e) {
      const related = e.relatedTarget
      if (!related || !$.contains($parent[0], related)) {
        $parent.removeClass('keyboard-focus')
      }
    })
  })
}

function initSocialSwitch() {
  // $('.social-switch__link').on('focusin', function () {
  //   $(this).parent('.social-container').addClass('keyboard-focus')
  //   $(this).attr('aria-expanded', 'true')
  // })

  /* $('.social-switch__link').on('focusout', function (e) {
    const related = e.relatedTarget
    if (!related || !$.contains($(this)[0], related)) {
      $(this).parent('.social-container').removeClass('keyboard-focus')
      $(this).attr('aria-expanded', 'false')
    }
  }) */

  $('.social-switch__link, .social-menu').on('mouseover focusin', function () {
    $('.social-switch__link').attr('aria-expanded', 'true')
  })

  $('.social-switch__link, .social-menu').on('mouseout focusout', function () {
    $('.social-switch__link').attr('aria-expanded', 'false')
  })

  $('.social-switch__link').on('keydown', function (e) {
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
      return
    }
    e.preventDefault()
    const $parent = $(this).parent('.social-container')
    const isExpanded = $parent.hasClass('keyboard-focus')
    if (isExpanded) {
      $parent.removeClass('keyboard-focus')
      $(this).attr('aria-expanded', 'false')
    } else {
      $parent.addClass('keyboard-focus')
      $(this).attr('aria-expanded', 'true')
    }
  })
}

function initPrintButton() {
  $('.btn-print').on('click', function (evt) {
    evt.preventDefault()
    window.print()
  })
}

function initMobileMenu() {
  $('.mobile-header-controller .icon-menu').on('click keydown', function (e) {
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
      return
    }
    $('.navbar__list').addClass('active')
    $('.lang-menu').removeClass('active')
    $('.search-menu').removeClass('active')
    $('.search-menu > form > *').attr('aria-hidden', 'true')
    $('.search-menu > form > *').attr('tabindex', '-1')

    //focus on first menu item
    setTimeout(() => {
      $('.navbar__list .navbar__item a').first().trigger('focus')
    }, 300)
  })
  $('.close-menu-button').on('click keydown', function (e) {
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
      return
    }
    $('.navbar__list').removeClass('active')
  })
  $('.mobile-header-controller .icon-lang').on('click keydown', function (e) {
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
      return
    }
    $('.lang-menu').toggleClass('active')
    $('.search-menu').removeClass('active')
    $('.search-menu > form > *').attr('aria-hidden', 'true')
    $('.search-menu > form > *').attr('tabindex', '-1')
    $('.navbar__list').removeClass('active')
  })
  $('.mobile-header-controller .icon-search').on('click keydown', function (e) {
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
      return
    }
    $('.search-menu').toggleClass('active')
    $('.lang-menu').removeClass('active')
    $('.navbar__list').removeClass('active')

    setTimeout(() => {
      if ($('.search-menu').hasClass('active')) {
        $('.search-menu > form > *').first().trigger('focus')
        $('.search-menu > form > *').attr('aria-hidden', 'false')
        $('.search-menu > form > *').removeAttr('tabindex')
      } else {
        $('.search-menu > form > *').attr('aria-hidden', 'true')
        $('.search-menu > form > *').attr('tabindex', '-1')
      }
    }, 500)
  })
  $('.mobile-header-controller .close__btn').on('click keydown', function (e) {
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
      return
    }
    $('.search-menu').removeClass('active')
    $('.search-menu > form > *').attr('aria-hidden', 'true')
    $('.search-menu > form > *').attr('tabindex', '-1')
  })

  $('.search-menu > form > *').attr('aria-hidden', 'true')
  $('.search-menu > form > *').attr('tabindex', '-1')
}

// Replace setMobileWidth() with this:
function initResponsiveViewport() {
  const BASE = 576 // your design baseline
  let rafId = null

  function getOrCreateViewportMeta() {
    let $meta = $('meta[name="viewport"]').eq(0)
    if ($meta.length === 0) {
      $meta = $('<meta name="viewport">').prependTo('head')
    }
    return $meta
  }

  function computeScale() {
    // Use innerWidth (includes scrollbars) and clamp with screen.width for odd browsers
    const w = Math.min(window.innerWidth || BASE, screen.width || BASE)
    return w <= BASE ? w / BASE : 1
  }

  function applyViewport() {
    const scale = computeScale()
    // Keep device-width for layout while controlling zoom with scale
    // Note: Using user-scalable=no can hurt accessibility; keep only if required.
    const content = `width=device-width, initial-scale=${scale}, maximum-scale=${scale}, user-scalable=no`
    getOrCreateViewportMeta().attr('content', content)
  }

  function scheduleUpdate() {
    if (rafId) cancelAnimationFrame(rafId)
    rafId = requestAnimationFrame(() => {
      rafId = null
      applyViewport()
    })
  }

  // Initial apply
  applyViewport()

  // React to changes
  window.addEventListener('resize', scheduleUpdate, { passive: true })
  window.addEventListener('orientationchange', scheduleUpdate, { passive: true })
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) scheduleUpdate()
  })

  // optional: expose a cleanup for SPA routes/unmounts
  return function cleanupResponsiveViewport() {
    window.removeEventListener('resize', scheduleUpdate)
    window.removeEventListener('orientationchange', scheduleUpdate)
    document.removeEventListener('visibilitychange', scheduleUpdate)
    if (rafId) cancelAnimationFrame(rafId)
  }
}

function initCurrentLocale() {
  if ($('body').hasClass('lang-en')) {
    currentLocale = 'en'
  }
  if ($('body').hasClass('lang-tc')) {
    currentLocale = 'tc'
  }
  if ($('body').hasClass('lang-sc')) {
    currentLocale = 'sc'
  }
}

function initSocialLinkButton() {
  _.each(['fb', 'twitter', 'whatsapp', 'weibo', 'weixin', 'link', 'email'], (key) => {
    $(`.social-link.${key}`).on('click', function () {
      getShare(key)
    })
  })
}

function getShare(media) {
  media.preventDefault
  var i = window.location.href
  var language = location.pathname.split('/')[1]

  switch (media) {
    case 'fb':
      window.open('http://www.facebook.com/sharer/sharer.php?u=' + i, '_blank')
      break
    case 'twitter':
      window.open('https://twitter.com/intent/tweet?text=' + i, '_blank')
      break
    case 'whatsapp':
      window.open('https://api.whatsapp.com/send?text=' + i, '_blank')
      break
    case 'weibo':
      var document_title = document.title
      window.open(
        'http://service.weibo.com/share/share.php?url=' +
          i +
          '&appkey=&title=' +
          document_title +
          '&pic=&ralateUid=&language=zh_cn',
        '_blank'
      )
      break
    case 'weixin':
      var new_window_weixin = window.open('', '', 'width=500,height=500')
      new_window_weixin.document.write(
        '<html><head><title>WeChat Share</title><script>const i = window.location.href; var language = location.pathname.split("/")[1];</script>'
      )
      new_window_weixin.document.write(
        '<script type="text/javascript" src="/libs/qrcode_wechat/qrcode.min.js"></script></head><body>'
      )
      new_window_weixin.document.write('<p id="share_text"></p>')
      new_window_weixin.document.write('<div id="qrcode"></div>')
      new_window_weixin.document.write(
        '<script>var share_text = document.getElementById("share_text"); if(language == "en"){ share_text.innerHTML = \'Scan QR Code in WeChat and tap "..." to share.\'}else if(language == "tc"){ share_text.innerHTML = "隢见銁敺桐縑銝剜���譍�𣬚雁蝣潛�嗅�峕�剹��...�滢誑��鈭�"}else{share_text.innerHTML ="霂瑕銁敺桐縑銝剜醌��譍�𣬚輕���嗅�峕�剹��...�滢誑��鈭�"};</script>'
      )
      new_window_weixin.document.write(
        '<script type="text/javascript">new QRCode(document.getElementById("qrcode"), i);</script>'
      )
      new_window_weixin.document.write('</body></html>')

      break
    case 'email':
      window.open('mailto:?subject=Hong Kong Fun in 18 Districts&body=' + i, '_blank')
      break
    case 'link':
      var dummy_copy = document.createElement('input')
      document.body.appendChild(dummy_copy)
      dummy_copy.value = i
      dummy_copy.select()
      document.execCommand('copy')
      document.body.removeChild(dummy_copy)
      var copied = document.querySelectorAll('.copied')
      for (var i = 0; i < copied.length; i++) {
        if (language == 'en') {
          copied[i].innerHTML = 'Copied'
        } else if (language == 'tc') {
          copied[i].innerHTML = '��𣂼�蠘��ˊ'
        } else {
          copied[i].innerHTML = '��𣂼�笔�滚�'
        }
      }
      break
  }
}

$(() => {
  initSocialLinkButton()
  initCurrentLocale()
  setupScrollToTop()
  setupNotificationCloseButton()
  initFooterBannerSwiper()
  initExploreItemsSwiper()
  initMapOverlay()
  initSelect()
  initFilters()
  initPagination()
  initLightbox()
  initRouteSafetyButton()
  initMapKeyboard()
  initKeyboardFocusObject()
  initSocialSwitch()
  initPrintButton()
  initMobileMenu()
  initResponsiveViewport()
  applyClosedNotifications()
})
